<template>

  <v-select 
    :value="value"
    @input="change"
    :options="options"
    :placeholder="placeholder">
    </v-select>

</template>

<script>
import momentTimezone from 'moment-timezone'

export default {
  name: 'SelectContract',
  props: [
    'value',
    'placeholder'
  ],
  data () {
    return {
    }
  },
  computed: {
    options () {
      return momentTimezone.tz.names()
    }
  },
  created () {
  },
  methods: {
    change (val) {
      if (val !== this.value) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectTimezone.vue